import { AwaitableEvent } from "./AwaitableEvent";

export class ConfirmDialogEvent extends AwaitableEvent<boolean> {
  constructor(public title: string, public body: string, opts?: { timeoutMs?: number }) {
    super(opts);
  }
}
